import { useAuth } from '@/contexts/routerProvider/authContext';
import { useIsLogin } from '@/contexts/routerProvider/isLoginContext';
import { useListTab } from '@/contexts/routerProvider/ListTabContext/hook';
import { STORAGE, storage } from '@/lib/storage';
import { findFirstActiveUrl } from '@/pages/ANONYMOUS/Home/components/LoginForm';
import { MenuItemAdmin } from '@/routerMap/MenuItem';
import ROUTER from '@/routerMap/ROUTER';
import { userProfileService } from '@/services/UserProfileService';
import { userService } from '@/services/UserService';
import { Login } from '@/types';
import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
export const addVTAndBHTab = (listTab: any[], user: Login) => {
  listTab = [
    ...listTab,
    { identity: 'UserInfor', description: 'thông tin cá nhân' },
  ];
  let findRequest: any = [];
  if (listTab?.length)
    findRequest = listTab.find(
      (item: any) => item.identity === 'Request Management',
    );
  if (findRequest) {
    if (user?.agent === 'VT' || user?.agent === 'ALL')
      listTab = [
        ...listTab,
        { identity: 'Request ManagementVT', description: 'VTS Vũng Tàu' },
      ];
    if (user?.agent === 'BH' || user?.agent === 'ALL')
      listTab = [
        ...listTab,
        { identity: 'Request ManagementBH', description: 'VTS Biên Hòa' },
      ];
  }
  if (listTab?.length)
    findRequest = listTab.find((item: any) => item.identity === 'Schedule');
  if (findRequest) {
    if (user?.agent === 'VT' || user?.agent === 'ALL')
      listTab = [
        ...listTab,
        { identity: 'ScheduleVT', description: 'VTS Vũng Tàu' },
      ];
    if (user?.agent === 'BH' || user?.agent === 'ALL')
      listTab = [
        ...listTab,
        { identity: 'ScheduleBH', description: 'VTS Biên Hòa' },
      ];
  }
  if (listTab?.length)
    findRequest = listTab.find((item: any) => item.identity === 'To Do List');
  if (findRequest) {
    if (user?.agent === 'VT' || user?.agent === 'ALL')
      listTab = [
        ...listTab,
        { identity: 'To Do ListVT', description: 'VTS Vũng Tàu' },
      ];
    if (user?.agent === 'BH' || user?.agent === 'ALL')
      listTab = [
        ...listTab,
        { identity: 'To Do ListBH', description: 'VTS Biên Hòa' },
      ];
  }
  return listTab;
};
const DefaultAction = () => {
  const { setListTab, setIsListTabLoaded } = useListTab();
  const navigate = useNavigate();
  const location = useLocation();
  const currentLocation = useRef(location);
  currentLocation.current = location;
  const { isLogin, setIsLogin } = useIsLogin();
  const { user, setUser } = useAuth();
  const getDetail = async () => {
    try {
      const response = await userProfileService.detail();
      if (response?.isError) return;
      const oldUserInfor = user;
      setUser({
        ...response?.data,
        token: oldUserInfor?.token,
        expiredAt: oldUserInfor?.expiredAt,
        username: oldUserInfor?.username,
        role: oldUserInfor?.role,
        listTab: oldUserInfor?.listTab,
        avatar: String(response?.data?.image),
        image: response?.data?.image,
        name: response?.data?.name,
        fullName: String(response?.data?.name),
        phone: response?.data?.phone,
        email: response?.data?.email,
        roleName: response?.data?.roleName,
        departmentName: response?.data?.departmentName,
        agent: response?.data?.agent,
        paidLeaveNumber: response?.data?.paidLeaveNumber,
      });
    } catch (error) {
      console.error(error);
    } finally {
      console.log('getDetail finish');
    }
  };
  const getListTab = async () => {
    try {
      const response = await userService.getListTab();
      if (response?.isError) return;
      let listTab: any = response?.data ?? [];
      listTab = addVTAndBHTab(listTab, user as Login);
      setListTab(listTab);

      // Chỉ tự chuyển trang khi đang đứng ở trang gốc. Trước đây điều hướng vô
      // điều kiện nên mọi đường dẫn chi tiết (ví dụ /request-pqr-.../999) đều bị
      // đá về menu đầu tiên mỗi lần F5 hoặc dán link vào trình duyệt.
      if (currentLocation.current.pathname === ROUTER.DEFAULT) {
        const menu = MenuItemAdmin();
        const listMenu = findFirstActiveUrl(menu, listTab);
        navigate(listMenu); // Chuyển sang trang chính
      }
    } catch (error) {
      console.error(error);
    } finally {
      // Dù API lỗi cũng phải mở khóa guard, nếu không trang treo ở spinner mãi.
      setIsListTabLoaded(true);
    }
  };
  useEffect(() => {
    if (isLogin) {
      getDetail();
      getListTab();
    }
  }, [isLogin]);
  useEffect(() => {
    const userInfo = storage.getLocalStorage<Login>(STORAGE.USER_INFO);
    if (!userInfo) return;

    try {
      setIsLogin(STORAGE.TOKEN);
      setUser(userInfo);

      // F5: dựng lại quyền ngay từ USER_INFO đã lưu lúc đăng nhập, để guard không
      // phải chờ API get-list-tab mới biết người dùng có quyền hay không.
      if (userInfo?.listTab?.length) {
        setListTab(addVTAndBHTab(userInfo.listTab, userInfo));
        setIsListTabLoaded(true);
      }
    } catch (e) {
      console.error('Lỗi parse USER:', e);
    }
  }, []);
  return <></>;
};

export default DefaultAction;
